import React from 'react';
import './FileTableRow.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function FileTableRow({file, file_ndx}) 
{
    const { app_user, action_item, setSelectedActionItem, setActionItemDisplayRefresh } = useCTAL();

    var UpdateDT = new Date(file.UpdatedAt);
    var datetime = new Date();
    var ageMS = datetime - UpdateDT;
    var ageSeconds = Math.round(ageMS / 1000);
    var ageMinutes = Math.round(ageSeconds / 60);
    var ageHours = Math.round(ageMinutes / 60);
    var ageDays = Math.round(ageHours / 24);
    var ageMonths = Math.round(ageDays / 30);

    var ageText;
    if (ageMonths < 1)
        if (ageDays < 1)
            if (ageHours < 1)
                if (ageMinutes < 1)
                    if (ageSeconds < 1)
                        ageText = `< 1 second`;
                    else
                        ageText = `${ageSeconds} ` + (ageSeconds == 1 ? "second" : "seconds");
                else
                    ageText = `${ageMinutes} ` + (ageMinutes == 1 ? "minute" : "minutes");
            else
                ageText = `${ageHours} ` + (ageHours == 1 ? "hour" : "hours");
        else
            ageText = `${ageDays} ` + (ageDays == 1 ? "day" : "days");
    else
        ageText = `${ageMonths} ` + (ageMonths == 1 ? "month" : "months");;
    
    const reset_action_item = () => { 
        setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
        setActionItemDisplayRefresh(true);  //Trigger the Action-Item bulk download in ActionItem.mjs
    }
    
    const parse_form_data = (form_data) => { 
        var object = {};
        form_data.forEach((value, key) => {
            // Reflect.has in favor of: object.hasOwnProperty(key)
            if(!Reflect.has(object, key)){
                object[key] = value;
                return;
            }
            if(!Array.isArray(object[key])){
                object[key] = [object[key]];    
            }
            object[key].push(value);
        });

        return object;
    }
    

    const handle_url = async (res) => {
        if (DEBUG) console.log(`FileTableRow - download url: ${res.url}`);
        let alink = document.createElement('a');
        alink.href = res.url;
        alink.download = file.FileName; //This is just a "suggestion", had to set original filename in db-updaters
        alink.click();
    }

    const send_delete_request = (form_data) => { 
        var obj = parse_form_data(form_data);   
        console.log(`FileTableRow - Delete File, type: ${obj.type}, file_id: ${obj.file_id}`);
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-file`, { method: "POST", body: form_data })
            .then(() => reset_action_item());
            //.catch(setError);
    }
    
    const send_download_request = (form_data) => { 
        var obj = parse_form_data(form_data);   
        console.log(`FileTableRow - Download File, type: ${obj.type}, file_id: ${obj.file_id}`);
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-file`, { method: "POST", body: form_data })
            .then(response => response.json())
            .then(handle_url);
            //.catch(setError);
    }

    const delete_file = () => {    
        const formData = new FormData();
        formData.append('type',           "delete_storage_file");
        formData.append('home_team_id',   file.HomeTeamID);
        formData.append('target_id',      file.TargetID);
        formData.append('file_id',        file.FileID);
        formData.append('user_full_name', app_user.UserFullName);

        send_delete_request(formData);
    }

    const download_file = () => {    
        const formData = new FormData();
        formData.append('type',           "create_storage_download_file_signed_url");
        formData.append('file_id',        file.FileID);

        send_download_request(formData);
    }

    return (
        <>
            <tr>
                <th scope="row">{file_ndx+1}</th>
                <td>{file.FileName}</td>
                <td>{file.FileSizeKB.toLocaleString("en-US")} KB</td>
                <td>{ageText}</td>
                <td>
                    <a href="#"><img class="file-icon" src="./images/download.svg" alt="download" border="0" onClick={download_file}/></a>
                    <a href="#"><img                   src="./images/trash.svg"    alt="delete"   border="0" onClick={delete_file}/></a>                                
                </td>
            </tr>
        </>
    );
}

/*
                    <a href="#"><img class="file-icon" src="./images/upload.svg"   alt="upload"   border="0"/></a>
                    <a href="#"><img class="file-icon" src="./images/view.svg"     alt="preview"  border="0"/></a>

*/

/* PREVIEW EXAMPLE
const image = document.querySelector(".my-image");
fetch("flowers.jpg")
  .then((response) => response.blob())
  .then((blob) => {
    const objectURL = URL.createObjectURL(blob);
    image.src = objectURL;
  });
*/